<template>
  <div>
    <card class="card-tyle">
      <div class="row">

        <div class="col-6 div-form-style">
          <div class="title-form-style">Criar nova notificação</div>
          <form class="row" @submit="onSubmit">
            <div class="col-12">
              <div class="sub-title-style">Gatilho de Notificação *</div>
              <select :disabled='campaignEdit' required class="form-control" v-model="type_notification_selected">
                <option value="null" disabled>Selecione um tipo...</option>
                <option
                  v-for="notification of type_notification"
                  :key="notification.type"
                  :value="notification.type"
                  >
                    {{notification.type_name}}
                </option>
              </select>
            </div>

            <!-- NOTIFICAÇÃO PADRÃO -->
            <template v-if="type_notification_selected">
              <div class="col-12">
                <div class="div-idi-style">Destino(idi) *
                  <span class="obs-title-style ml-1">(Separados por vírgula + espaço Ex:'idi1, idi2')</span>
                  <span class="checkbox-style ml-2">
                    <input @click="changeIdisDestiny()" :disabled="isForAll || campaignEdit" type="checkbox" id="checkbox" v-model="checkBoxTag"/>
                    <span class="ml-2 mb-0 obs-title-style">Usar tags</span>
                  </span>
                  <span class="checkbox-style ml-2">
                    <input @click="handleIsForAll()" :disabled='campaignEdit' type="checkbox" id="forAll" v-model="isForAll"/>
                    <span class="ml-2 mb-0 obs-title-style">Enviar para Todos</span>
                  </span>
                </div>
                <input :required="!disabled_idis_destiny" :disabled="disabled_idis_destiny || isForAll || campaignEdit" @keyup="countIdis" v-model="idis_destiny" class="form-control">
              </div>
              <div class="col-12">
                <div class="sub-title-style">Tags * <router-link to="/tag-insertion" class="btn btn-primary m-0 ml-2 p-2">Nova tag</router-link></div>
                <select @change="changeTagListTags" :required="disabled_idis_destiny" :disabled="!disabled_idis_destiny || isForAll || campaignEdit" class="form-control" v-model="tag_selected">
                  <option
                    v-for="tag of tags"
                    :key="tag.id"
                    :value="tag"
                    >
                      {{tag.name}}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <div class="sub-title-style">Plataformas *</div>
                <div class='platform-selected-style'>
                  <div v-for="plataform in type_platform" :key="plataform.type">
                    <label>
                      <input
                      @change="checkPlatformSelected"
                      class="form-control"
                      :disabled='campaignEdit'
                      :required='!check_platform_selected'
                      type="checkbox"
                      v-model="platform_selected"
                      :value="plataform.type">
                      {{ plataform.name_plataform }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-12 date-style">
                <div class="col-6 p-0 pr-2">
                  <div class="sub-title-style">Data de início:</div>
                  <input :disabled='campaignEdit' required v-model="startDate" type="date" class="form-control">
                </div>
                <div class="col-6 p-0 pl-2">
                  <div class="sub-title-style" >Data de fim:</div>
                  <input :disabled='campaignEdit' required v-model="finalDate" type="date" class="form-control">
                </div>
              </div>
              <div class="col-12 div-icon-style" v-if="type_notification_selected != 'ONLY_NOTIFICATION' && type_notification_selected != 'NPS'">
                <div class="sub-title-style">Upload de Imagens</div>
                <input type="file" @change="upload">
              </div>
              <div class="col-12">
                <div class="sub-title-style">Título * <span class="obs-title-style">(Máximo de 100 caracteres)</span></div>
                <input :required="type_notification_selected != 'NPS'" :disabled="type_notification_selected == 'NPS'" maxlength="100" type="text" v-model="title" class="form-control">
              </div>
              <div class="col-12" v-if="type_notification_selected != 'ONLY_MODAL_NOTIFICATION'">
                <div class="sub-title-style">Subtítulo * <span class="obs-title-style">(Máximo de 150 caracteres)</span></div>
                <textarea maxlength="150" :required="type_notification_selected != 'NPS'" :disabled="type_notification_selected == 'NPS'" v-model="subtitle" class="form-control"></textarea>
              </div>
              <div class="col-12" v-if="type_notification_selected != 'ONLY_NOTIFICATION'">
                <div class="div-idi-style">Descrição *
                  <!-- <span class="checkbox-style ml-2">
                    <input type="checkbox" id="checkbox" v-model="checkBoxIframe"/>
                    <span class="ml-2 mb-0 obs-title-style">Adicionar um iframe</span>
                  </span> -->
                </div>
                <textarea :required="type_notification_selected != 'NPS'" :disabled="type_notification_selected == 'NPS'" v-model="description" class="form-control description-style"></textarea>
              </div>
              <div class="col-12" v-if="type_notification_selected != 'ONLY_NOTIFICATION'">
                <div class="sub-title-style">Título do botão *</div>
                <input type="text" :required="type_notification_selected != 'NPS'" :disabled="type_notification_selected == 'NPS'" v-model="btn_title" class="form-control">
              </div>
              <div class="col-12" v-if="type_notification_selected != 'ONLY_NOTIFICATION'">
                <div class="div-idi-style">Link do botão * <span class="obs-title-style">(Com "https://")</span>
                  <span class="checkbox-style ml-2">
                    <input :disabled="type_notification_selected == 'NPS'" @click="closeModal()" type="checkbox" id="checkbox"/>
                    <span class="ml-2 mb-0 obs-title-style">Fechar o modal</span>
                  </span>
                </div>
                <input :required="type_notification_selected != 'NPS'" type="text" v-model="btn_link" :disabled="close_modal || type_notification_selected == 'NPS'" class="form-control">
              </div>
              <div class="col-12" v-if="type_notification_selected != 'ONLY_NOTIFICATION'">
                <div class="sub-title-style">Evento *</div>
                <input :required="type_notification_selected != 'NPS'" :disabled='campaignEdit || type_notification_selected == "NPS"' type="text" v-model="eventName" class="form-control">
              </div>

              <div class="form-group col-12 btn-criar-style">
                <button v-if="!campaignEdit" class="btn btn-primary">Criar notificação</button>
                <button v-if="campaignEdit" class="btn btn-primary">Salvar Edição</button>
              </div>
            </template>
          </form>
        </div>

        <!-- PRÉ-VISUALIZAÇÃO -->
        <div class="col-6">
          <div class="preview-style">
            <div class="col-7 select-preview-style">
            <div v-if="type_notification_selected" class="sub-title-preview-style" >Tipo de pré-visualização</div>
            <select v-if="type_notification_selected" class="form-control" v-model="preview_selected">
              <option
                v-for="option of preview_options"
                :key="option.type"
                :value="option.type"
                >
                  {{option.name_preview}}
              </option>
            </select>
            </div>

            <!-- SEM DADOS DE PRÉ-VISUALIZAÇÃO -->
            <div class="preview-without-info" v-if="!preview_selected">
              <img class="logo" src="@/assets/img/notification-preview.svg"/>
            </div>

            <!-- NOTIFICAÇÃO  -->
            <div v-if="preview_selected == 'notification'" class="div-preview-notification">
              <div class="col-10 preview-notification">
                <div class="title-notification-style">Notificações</div>
                <div class="row py-1 pointer backgorund">
                  <div class="icon-style col-2">
                    <img v-if="this.icon" :src="this.icon">
                    <img v-if="!this.icon" src="@/assets/img/icon-preview-notification.svg">
                  </div>
                  <div class="col-10">
                    <div v-if="title" class="title-style">{{title}}</div>
                    <div v-if="!title" class="title-style">Preencha o campo "Título"</div>
                    <div v-if="subtitle" class="short-text">{{subtitle}}</div>
                    <div v-if="!subtitle" class="short-text">Preencha o campo "Subtítulo"</div>
                    <div class="time-style">Há segundos atrás</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- MODAL -->
            <div v-if="preview_selected == 'modal' && type_notification_selected == 'ONLY_NOTIFICATION'" class="div-preview-modal">
              <span>Neste tipo de notificação não existe modal.</span>
            </div>
            <div v-if="preview_selected == 'modal' && type_notification_selected != 'ONLY_NOTIFICATION'" class="div-preview-modal">
              <div class="col-10 preview-modal">
                <div class="btn-close-style">
                  <img src="@/assets/img/icon-close-modal.svg">
                </div>
                <div class="icon-modal-style col-12">
                  <img v-if="this.icon" :src="this.icon">
                </div>
                <div v-if="title" class="title-modal-style">{{title}}</div>
                <div v-if="!title" class="title-modal-style">Preencha o campo "Título"</div>
                <div v-if="description && !checkBoxIframe" class="long-description-style">{{description}}</div>
                <iframe v-if="description && checkBoxIframe" :src='description' class="iframe-style"></iframe>
                <div v-if="!description" class="long-description-style">Preencha o campo "Descrição"</div>
                <div class="btn-modal-style">
                  <button class="" v-if="!btn_title">Clique aqui e saiba mais!</button>
                  <button class="" v-if="btn_title">{{btn_title}}</button>
                </div>
              </div>
            </div>

            <!-- CLIENTES AFETADOS -->
            <div v-if="(idis_destiny || list_tag_selected) && estimate_of_idis_affected < 2 && !isForAll" class="col-12 div-idis-affected">
              Aproximadamente <strong> {{estimate_of_idis_affected}} </strong> cliente receberá essa notificação.
            </div>
            <div v-if="(idis_destiny || list_tag_selected) && estimate_of_idis_affected > 1 && !isForAll" class="col-12 div-idis-affected">
              Aproximadamente <strong> {{estimate_of_idis_affected}} </strong> clientes receberão essa notificação.
            </div>
            <div v-if="isForAll" class="col-12 div-idis-affected">
              <strong> TODOS CLIENTES </strong> da base receberão essa notificação.
            </div>

          </div>
        </div>

      </div>
    </card>
  </div>
</template>

<script>

import axios from 'axios'
import { Card } from 'src/components'
import NotificationService from '@/services/NotificationService.js'
import moment from 'moment'

export default {
    components: {
      Card,
    },
    data() {
      return {
        campaignEdit: null,
        type_notification_selected: null,
        close_modal:false,
        type_notification:
          [
            {
              type: 'SIMPLE_NOTIFICATION',
              type_name: 'Modal e Notificação',
            },
            {
              type: 'MODAL_AND_NOTIFICATION',
              type_name: 'Modal e Notificação (Modal Automático)',
            },
            {
              type: 'ONLY_MODAL_NOTIFICATION',
              type_name: 'Somente Modal Automático',
            },
            {
              type: 'ONLY_NOTIFICATION',
              type_name: 'Somente notificação',
            },
            {
              type: 'NPS',
              type_name: 'Pesquisa de NPS',
            },
          ],
        preview_options: [
          {
            type: 'notification',
            name_preview: 'Prévia - Notificação no Dashboard'
          },
          {
            type: 'modal',
            name_preview: 'Prévia - Modal no Dashboard'
          }
        ],
        preview_selected: null,
        checkBoxTag: false,
        isForAll: false,
        metadata_idis: [],
        idis_destiny: '',
        disabled_idis_destiny: false,
        tags: [],
        check_platform_selected: false,
        platform_selected: [],
        startDate: '',
        finalDate: '',
        type_platform: [
          {
            type: 'YOOGA_APP',
            name_plataform: 'App',
            checked:false

          },
          {
            type: 'PANEL',
            name_plataform: 'Painel',
            checked:false
          },
          {
            type: 'ISSUER',
            name_plataform: 'Emissor',
            checked:false
          }
        ],
        tag_id: null,
        tag_selected: null,
        list_tag_selected: null,
        estimate_of_idis_affected: null,
        title: '',
        icon: null,
        subtitle: '',
        description: '',
        checkBoxIframe: false,
        btn_title: '',
        btn_link: '',
        eventName: '',
      }
    },
    props: {},
    methods:{
      loadEditcampaign(idCampaign) {
        NotificationService.loadEditcampaign(idCampaign).then(res => {
          this.campaignEdit = JSON.parse(res.data[0].metadata)
          this.type_notification_selected = res.data[0].type
          this.startDate = moment(res.data[0].start_date).format('YYYY-MM-DD')
          this.finalDate = moment(res.data[0].final_date).format('YYYY-MM-DD')
          this.icon = this.campaignEdit.svg_icon
          this.title = this.campaignEdit.title
          this.checkBoxIframe = res.data[0].iframe_added
          this.subtitle = this.campaignEdit.short_description
          this.description = this.campaignEdit.long_description
          this.btn_title = this.campaignEdit.buttons[0].btn_title
          this.btn_link = this.campaignEdit.buttons[0].btn_link
        }).catch(err => {});
      },
      closeModal(){
        if(!this.close_modal){
          this.close_modal = true
          this.btn_link = " "
        }else{
          this.close_modal = false;
        }
      },
      countIdis() {
        if(this.idis_destiny) {
          this.idis_destiny = this.idis_destiny.toString().split(',')
          this.estimate_of_idis_affected = this.idis_destiny.length
        } else
        if(this.list_tag_selected){
          this.estimate_of_idis_affected = this.list_tag_selected.idiCount
        }
      },
      changeIdisDestiny() {
        this.estimate_of_idis_affected = ''
        if(this.checkBoxTag){
          this.list_tag_selected = ''
          this.tag_selected = ''
          this.disabled_idis_destiny = false
        } else {
          this.idis_destiny = ''
          this.disabled_idis_destiny = true
        }
      },
      handleIsForAll() {
        this.estimate_of_idis_affected = ''
        this.list_tag_selected = ''
        this.tag_selected = ''
        this.idis_destiny = ''
      },
      changeTagListTags() {
        this.list_tag_selected = this.tag_selected
        this.countIdis()
      },
      checkPlatformSelected() {
        if(this.platform_selected.length) {
          this.check_platform_selected = true
        } else {
          this.check_platform_selected = false
        }
      },
      upload(file) {
        var data = new FormData();
        data.append('file', file.target.files[0]);
        axios.post(process.env.VUE_APP_NEST_NOTIFICATION + 'upload', data, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
          this.icon = res.data[0].url
        }).catch(err => {
        });

      },
      setImage: function (file) {
        this.hasImage = true
        this.prevImgUrl = file.dataUrl;
        this.image = file
        console.log(file)
        this.upload(this.dataURLtoFile(file.dataUrl, file.info  && file.info.name ? file.info.name : file.name))
      },
      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
      },
      onSubmit(e) {
        e.preventDefault()

        if(this.idis_destiny) {
          this.metadata_idis = this.idis_destiny.toString().split(',').map(function(x) {
            return parseInt(x);
          });
        } else
        if(this.list_tag_selected){
          this.tag_id = this.tag_selected.id
        }


        let metadata = {
          type: this.type_notification_selected,
          campaign_name: this.type_notification_selected == 'NPS' ? "Pesquisa de NPS" : this.title,
          targets: this.metadata_idis,
          tag_id: this.tag_id,
          isForAll: this.isForAll,
          iframeAdded: this.checkBoxIframe,
          eventText: this.eventName,
          destiny: this.platform_selected,
          startDate: this.startDate,
          finalDate: this.finalDate,
          metadata: {
            svg_icon: this.icon,
            title: this.title,
            short_description: this.subtitle,
            long_description: this.description,
            buttons: [
              {
                btn_title: this.btn_title,
                btn_link: this.btn_link
              }
            ]
          }
        }

        if(this.campaignEdit){
        let convertIframeAdded = metadata.iframeAdded == true ? 1 : 0
        NotificationService.patch(this.$route.params.id, metadata.metadata, convertIframeAdded).then(res => {
          this.$swal({
            type: "success",
            title:"Sucesso!",
            text:"Campanha editada com sucesso!",
            timer: 3000
          })
          this.$router.push('/notifications-list/')
        }).catch(err => {
            this.$swal({
              type: "error",
              title: "Ops... algo deu errado!",
              text: 'Verifique os campos preenchidos!',
              timer: 3000
            })
        });
        } else {
          NotificationService.post(metadata).then(res => {
            this.$swal({
              type: "success",
              title:"Sucesso!",
              text:res.data.message,
              timer: 3000
            })
            this.$router.push('/notifications-list/')
          }).catch(err => {
            this.$swal({
              type: "error",
              title: "Ops... algo deu errado!",
              text: 'Verifique os campos preenchidos!',
              timer: 3000
            })
          });
        }

      }
    },
    mounted() {
      if(this.$route.params.id){
        this.loadEditcampaign(this.$route.params.id)
      }
      axios.get(process.env.VUE_APP_NEST_CAMPAIGN + 'tag/installations').then(res => {
        this.tags = res.data
      }).catch(err => {
        console.error(err)
      });
    }
}
</script>

<style lang="scss">
.div-form-style{
  height: 100%;
}

.card-tyle {
  min-height: 500px;
}

.title-form-style {
  color: #032351;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 25px;
}

.obs-title-style {
  font-weight: 400;
  font-size: 12px;
}

.checkbox-style {
  display: flex;
  align-items: center;
}

.div-icon-style {
  text-align: start;

  input {
    margin-left: 5px;
  }

  img {
    margin-right: 15px;
    margin-left: 5px;
    width: 40px;
  }
}

.sub-title-style {
  margin-top: 14px;
  padding: 5px;
  text-align: left;
  color: #032351;
  font-weight: 600;
  font-size: 16px;
}

.div-idi-style {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-top: 14px;
  padding: 5px;
  text-align: left;
  color: #032351;
  font-weight: 600;
  font-size: 16px;
}

.platform-selected-style {
  display: flex;
  padding-left: 5px;

  label {
    display: flex;
    margin-right: 10px;
    font-size: 15px;
    color: #1C1C1C;

    input {
      margin-right: 5px;
      height: 21px !important;
    }
  }
}

.date-style {
  display: flex;
}

.description-style {
  height: 150px !important;
  max-height: none !important;
}

.iframe-style {
  width: 100%;
  height: 310px;
  border: none;
}

.btn-criar-style {
  margin-top: 14px;
}

.preview-style {
  background: #EBF1F2;
  height: 100%;
  border-radius: 5px;
}

.preview-without-info {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 85%;

  img {
    padding: 20px;
  }
}

.sub-title-preview-style {
  padding: 5px;
  margin-bottom: 5px;
  text-align: left;
  color: #032351;
  font-weight: 600;
  font-size: 16px;
}

.select-preview-style {
  padding-top: 15px;
  height: 8%;

  select {
    background: #FFFF;
  }
}

.div-preview-notification {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85%;
}

.preview-notification {
  background: #FFFF;
  height: 200px;
  border-radius: 5px;
}

.title-notification-style {
  margin-top: 14px;
  margin-bottom: 10px;
  padding: 5px;
  text-align: left;
  color: #032351;
  font-weight: 600;
  font-size: 20px;
}

.backgorund {
  background: #E7F7FF;
}

.icon-style {
  display: flex;
  justify-content: center;
  align-items: baseline;

  img {
    height: 35px;
    margin-top: 5px;
  }
}

.title-style {
  font-weight: 600;
  font-size: 18px;
  padding-right: 10px;
}

.short-text {
  color: #646464;
  font-weight: 400;
  font-size: 16px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.time-style {
  font-size: 16px;
  font-weight: 400;
}

.div-preview-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.preview-modal {
  background: #FFFF;
  height: 489px;
  width: 450px;
  border-radius: 10px;
  padding: 16px;
  overflow: auto;
}

.btn-close-style{
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 5px;
  padding-top: 0px;
  padding-bottom: 0px;

  img {
    height: 19px;
  }
}

.icon-modal-style {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 186px;
    width: 100%;
    border-radius: 5px;
    margin-top: 5px;
  }
}

.title-modal-style {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 8px;
  padding-left: 30px;
  padding-right: 30px;
  color: #032351;
  font-weight: 600;
}

.long-description-style {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: justify;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 16px;
  color: #697473;
  white-space: pre-wrap;
}

.btn-modal-style {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 15px;

  button {
    height: 40px;
    width: 100%;
    color: #FFFFFF;
    background: #19A1E6;
    border-radius: 5px;
    outline:none !important;
    border: none;
    transition: all .3s;
    font-size: 14px;
  }
}

.div-idis-affected {
  display: flex;
  justify-content: center;
  color: #3C5373;
  font-size: 16px;

  strong {
    margin-left: 8px;
    margin-right: 8px;
  }
}
</style>
